/**
 * O que faz: concentra a importação lazy e o pre-carregamento da página Pipeline.
 * Onde usa: App.tsx e Sidebar.tsx.
 * Conexões: React.lazy, retry de chunks e importação dinâmica do Vite.
 * Tabelas: nenhuma.
 * Data: 28/08/2026
 */

import { carregarModuloComRetry } from '@/lib/recarregarAposFalhaDeChunk';
import { criarPrecarregador } from './criarPrecarregador';

// A mesma função mantém o chunk identificável e compartilhado entre lazy e preload.
const importarPipelinePage = () => import('@/pages/PipelinePage');

export const PipelinePageLazy = carregarModuloComRetry(importarPipelinePage);
export const preCarregarPipeline = criarPrecarregador(importarPipelinePage);
